import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import pako from 'pako';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';
import $ from 'jquery';

/* Actions */
import * as calculationsHistoryActions from '../../actions/calculationsHistory/index';

/*Components*/
import CalculationDetailPopup from '../../components/calculationsHistory/calculationDetailPopup';

class CalculationDetailPopupContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calculationDetailPopupTree: null,
      showMetricsPanel: null,
      markedMetric: null,
      actualMetricQuery: null
    };
  }
 
  componentDidMount() {
  }
  
  componentWillUnmount() {
  }
  
  componentDidUpdate(prevProps) {   
    if(InterfaceTooling.popupHasToRender(this.props.popupState)) {
      if (this.props.calculationDepurationDetail.status===200 && prevProps.calculationDepurationDetail.status !==200) {
        let calculationDetailPopupTree = 
          JavascriptUtilsTooling.deepCopy(this.props.calculationDepurationDetail.data.calculated_simplified_ast);
        calculationDetailPopupTree.show = true;
        this.setState({
          calculationDetailPopupTree: calculationDetailPopupTree,
          showMetricsPanel: false,
          markedMetric: null
        });        
      }

      //handle export metrics data feedback
      InterfaceTooling.apiCallResultFeedback(
        [prevProps.calculationDepurationDetailExportMetricData.status],
        [this.props.calculationDepurationDetailExportMetricData.status],
        intl.formatMessage({ id: "metricDataAdmin.exportMetricsDataSuccess" }),
        intl.formatMessage({ id: "metricDataAdmin.exportMetricsDataFailure" })
      );
    }
  }

  handleCloseAllCalculationDetailPopupTreeRecursive = (node) => {
    if(node.childs) {
      node.markError = false;
      node.childs.forEach(child => {
        child.show = false;
        child.markError = false;
        this.handleCloseAllCalculationDetailPopupTreeRecursive(child);
      });
    }
  };

  handleOpenCloseCalculationDetailPopupTreeRecursive = (node, targetNodeId) => {
    if(node.id==targetNodeId) {
      if(node.childs) {
        node.childs.forEach(child => {
          child.show = child.show ? false : true;
        });
      }
      return true;
    }    
    if(node.childs) {
      for (let i = 0; i < node.childs.length; i++) {
        if(this.handleOpenCloseCalculationDetailPopupTreeRecursive(node.childs[i],targetNodeId)) {
          return true;
        }
      }
    }
    return false
  };

  handleDecompressCalculationDetailPopupTreeNodeRecursive = (node, targetNodeId) => {
    if(node.childs) {
      for (let i = 0; i < node.childs.length; i++) {
        if(node.childs[i].id == targetNodeId) {
          if(node.childs[i].type_code == "CompressedNode" && node.childs[i].compressed_content) {
            // decompress node
            let binaryString = window.atob(node.childs[i].compressed_content);
            let bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            let decompressed = pako.inflate(bytes, { to: 'string' });
            node.childs[i] = JSON.parse(decompressed);
            node.childs[i].show = true;
          }
          return true;
        }
        else if(this.handleDecompressCalculationDetailPopupTreeNodeRecursive(node.childs[i],targetNodeId)) {
          return true;
        }
      }
    }
    return false
  };

  handleOpenCloseCalculationDetailPopupTree = event => {
    var nodeId = event.currentTarget.dataset.id;
    if(this.state.calculationDetailPopupTree) {
      this.handleOpenCloseCalculationDetailPopupTreeRecursive(this.state.calculationDetailPopupTree, nodeId);
      this.setState({
        calculationDetailPopupTree: this.state.calculationDetailPopupTree
      });
    }
  };

  handleDecompressCalculationDetailPopupTreeNode = event => {
    var nodeId = event.currentTarget.dataset.id;
    if(this.state.calculationDetailPopupTree) {
      this.handleDecompressCalculationDetailPopupTreeNodeRecursive(this.state.calculationDetailPopupTree, nodeId);
      this.setState({
        calculationDetailPopupTree: this.state.calculationDetailPopupTree
      });
    }
  };

  handleGoToErrorCalculationDetailPopupTreeRecursive = (node, targetNodeId) => {
    if(node.id==targetNodeId) {
      node.show = true;
      node.markError = true;
      return true;
    }    
    if(node.childs) {
      for (let i = 0; i < node.childs.length; i++) {
        if(this.handleGoToErrorCalculationDetailPopupTreeRecursive(node.childs[i],targetNodeId)) {
          node.show = true;
          node.childs.forEach(child => {
            child.show = true;
          });
          return true;
        }
      }
    }
    return false
  };

  handleGoToErrorCalculationDetailPopupTree = event => {
    var nodeId = event.currentTarget.dataset.id;
    if(this.state.calculationDetailPopupTree) {
      this.handleCloseAllCalculationDetailPopupTreeRecursive(this.state.calculationDetailPopupTree);
      this.handleGoToErrorCalculationDetailPopupTreeRecursive(this.state.calculationDetailPopupTree, nodeId);
      this.setState({
        calculationDetailPopupTree: this.state.calculationDetailPopupTree
      });
      InterfaceTooling.delayCallAction(
        ()=>{
          let dom_search = $(".depuration_tree_marked_error");
          if(dom_search.length>0) {
            $(".depuration_tree_marked_error")[0].scrollIntoView();
          }
        },null);      
    }
  };

  handleCloseAllCalculationDetailPopupTree = event => {
    if(this.state.calculationDetailPopupTree) {
      this.handleCloseAllCalculationDetailPopupTreeRecursive(this.state.calculationDetailPopupTree);
      this.setState({
        calculationDetailPopupTree: this.state.calculationDetailPopupTree
      });
    }
  };

  handleCloseCalculationDetailMetricData = (event) => {
    this.setState({
      showMetricsPanel: false,
      markedMetric: null
    });
  };

  handleGetCalculationDetailMetricData = (event) => {
    event.stopPropagation();
    let nodeObject = JSON.parse(event.currentTarget.dataset.nodedata);
    this.props.actions.getMetricData({
      calculation_id: this.props.calculationDepurationDetail.data.id,
      metric_query_data: nodeObject.metric_query_data,
      page: 1,
      per_page: Constants.interface.metricDataListPageSize
    });
    this.setState({
      actualMetricQuery: nodeObject.metric_query_data,
      showMetricsPanel: true,
      markedMetric: nodeObject.id
    });
    InterfaceTooling.delayCallAction(
      ()=>{
        let dom_search = $(".depuration_tree_marked_metric");
        if(dom_search.length>0) {
          $(".depuration_tree_marked_metric")[0].scrollIntoView();
        }
      },null);
  };

  fetchCalculationDetailMetricsDataNextPage = async (event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(this.props.calculationDepurationDetailMetricData.status === 200 && 
       this.props.calculationDepurationDetailMetricData.page<=this.props.calculationDepurationDetailMetricData.totalPages) {
      await this.props.actions.getMetricData({
        calculation_id: this.props.calculationDepurationDetail.data.id,
        metric_query_data: this.state.actualMetricQuery,
        page: page,
        per_page: Constants.interface.metricDataListPageSize,
      }, true);
    }  
  };

  handleCalculationDetailExportMetricData = async () => {
    if(this.props.calculationDepurationDetailExportMetricData.totalRecords>Constants.metricDataAdmin.exportLimit) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage( 
        {id: "metricDataAdmin.exportLimitError"},
        {limit: Constants.metricDataAdmin.exportLimit})
     ,"");       
      return;
    }
    await this.props.actions.exportMetricData({
      calculation_id: this.props.calculationDepurationDetail.data.id,
      metric_query_data: this.state.actualMetricQuery
    });
  };

  render() {
    return (
        <CalculationDetailPopup
          handleShowPopup={this.props.handleCalculationDetailPopup}
          fullLoading={this.props.calculationDepurationDetail.loading}
          calculationDetailData={this.props.calculationDepurationDetail.data}
          calculationDetailPopupTree={this.state.calculationDetailPopupTree}
          calculationDepurationDetailMetricData={this.props.calculationDepurationDetailMetricData}
          handleOpenClose={this.handleOpenCloseCalculationDetailPopupTree}
          handleDecompressNode={this.handleDecompressCalculationDetailPopupTreeNode}
          handleGoToError={this.handleGoToErrorCalculationDetailPopupTree}
          handleCloseAll={this.handleCloseAllCalculationDetailPopupTree}
          handleGetMetricData={this.handleGetCalculationDetailMetricData}
          fetchMetricsDataNextPage={this.fetchCalculationDetailMetricsDataNextPage}
          showMetricsPanel={this.state.showMetricsPanel}
          markedMetric={this.state.markedMetric}
          handleCloseMetricData={this.handleCloseCalculationDetailMetricData}
          handleExportMetricsData={this.handleCalculationDetailExportMetricData}
          loadingExportMetricData={this.props.calculationDepurationDetailExportMetricData.loading}
          popupTitle={this.props.popupTitle}
          popupState={this.props.popupState}
        />
    );
  }
}

const mapStateToProps = state => ({
  calculationDepurationDetail: state.reducer.calculationsHistory.calculationDepurationDetail,
  calculationDepurationDetailMetricData: state.reducer.calculationsHistory.calculationDepurationDetailMetricData,
  calculationDepurationDetailExportMetricData: state.reducer.calculationsHistory.calculationDepurationDetailExportMetricData
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(calculationsHistoryActions, dispatch)
});

CalculationDetailPopupContainer.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CalculationDetailPopupContainer);



// WEBPACK FOOTER //
// ./source/client/containers/calculationsHistory/calculationDetailPopupContainer.jsx